/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { ActionButton } from '@blend/enterprise-components';

export namespace NewMessageBtn {
  export interface Props {
    handleClick: () => void;
  }
}

export const NewMessageBtn: React.FC<NewMessageBtn.Props> = ({ handleClick }) => (
  <ActionButton btnSize="md" icon="add" id="it-new-message-btn" label="New message" onClick={handleClick} />
);
